import { GANHE_MAIS_CORRETOR_CLIENT_URL } from '../../constants/ClientUrls';

export const PRIVACY_POLICY_URL =
  'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPOLI%CC%81TICA%20DE%20PRIVACIDADE%20LGPD%20COMPLIANCE%202026.pdf?alt=media&token=f6339049-9c75-4ac2-8417-a70c9d75be94';

// Clientes com cadastro próprio, que o chat não cobre.
const CUSTOM_SIGNUP_CLIENT_URLS = [
  'brconsorcio',
  GANHE_MAIS_CORRETOR_CLIENT_URL,
];

/** O chat aparece só para clientes ativos com a flag ligada no admin. */
export function isAiSignupAvailable(client: any): boolean {
  if (!client || !client.id || client.active === false) return false;
  if (client.settings?.isAiSignupEnabled !== true) return false;
  if (client.isTeamCompetition === 'true') return false;
  if (CUSTOM_SIGNUP_CLIENT_URLS.includes(client.clientUrl)) return false;
  return true;
}
